export default select => {
  return {
    name: 'VsSelect',
    computed: {
      select() {
        return this.$children[0];
      }
    },
    methods: {
      clickBlur(event){
        let closestx;
        if (event.target == document.body) {
          closestx = event.target.getElementsByClassName("vs-select--options").item(0);
        } else {
          closestx = event.target.closest(".vs-select--options");
        }

        if (!closestx) {
          this.select.closeOptions();
          if (this.autocomplete) {
            this.select.filterItems("");
          }
          this.select.changeValue();
        }
      }
    },
    mounted() {
      this.select.$refs.inputselect.autocomplete = 'off';
      if (this.$listeners.keyup) {
        this.select.$refs.inputselect.onkeyup = this.$listeners.keyup
      }
      this.select.clickBlur = this.clickBlur;
    },
    beforeDestroy() {},
    render(h) {
      const slots = Object.keys(this.$slots).reduce((arr, key) => arr.concat(this.$slots[key]), []);
      return h(select, {
        attrs: this.$attrs,
        props: this.$props,
        on: this.$listeners,
      }, slots);
    }
  }
};
